import { render, staticRenderFns } from "./board-password.vue?vue&type=template&id=498019ce"
import script from "./board-password.vue?vue&type=script&lang=ts"
export * from "./board-password.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports